<template>
  <div class="wrap">
    <div class="title">蔵衛門ID新規登録</div>
    <div class="form-wrap">
      <ValidationObserver tag="form">
        <div class="form-label">メールアドレス(必須)</div>
        <div class="form-row">
          <ValidationInput field-name="メールアドレス"
                           meta-name="mail"
                           :valid-rules="mailRules"
                           ref="mailInput">
            <input type="email"
                   v-model="reg.mail" />
          </ValidationInput>
        </div>
        <div class="form-label">パスワード(必須)</div>
        <div class="form-row">
          <ValidationInput field-name="パスワード"
                           meta-name="password"
                           :valid-rules="passwordRules"
                           ref="passwordInput">
            <input type="password"
                   v-model="reg.password" />
          </ValidationInput>
        </div>
        <div class="form-label">パスワード確認(必須)</div>
        <div class="form-row">
          <ValidationInput field-name="パスワード確認"
                           :valid-rules="passwordConfirmRules"
                           ref="passwordConfirmInput">
            <input type="password"
                   v-model="passwordConfirm" />
          </ValidationInput>
        </div>
        <div class="form-label">会社名</div>
        <div class="form-row">
          <input type="text"
                 v-model="reg.companyName" />
        </div>
        <div class="form-label">氏名(必須)</div>
        <div class="form-row">
          <ValidationInput field-name="氏名"
                           meta-name="user_name"
                           :valid-rules="userNameRules"
                           ref="userNameInput">
            <input type="text"
                   v-model="reg.userName" />
          </ValidationInput>
        </div>
        <div class="form-label">業種</div>
        <div class="form-row">
          <select v-model="reg.industry">
            <option v-for="industryOption in industryOptions"
                    :key="industryOption.value"
                    :disabled="industryOption.disabled"
                    :value="industryOption.value">
              {{ industryOption. text }}              
            </option>
          </select>
        </div>
        <div class="form-label">お知らせの配信</div>
        <div class="form-row">
          <label>
            <input type="checkbox"
                   class="checkbox-input"
                   v-model="reg.receiveNotification">
            <span class="checkbox-parts"
                  :class="{checked: reg.receiveNotification}">
              配信を希望する
            </span>
          </label>
        </div>
      </ValidationObserver>
      <div class="caption">
        蔵衛門IDの登録には<router-link :to="{ name: 'terms-of-service' }" rel="noopener" target="_blank">規約</router-link>への同意が必要です
      </div>
      <div class="btn-wrap">
        <button class="btn next-btn"
                @click="checkParams"
                :disabled="!isValid()">
          同意して次へ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationInput from '@/components/ui/ValidationInput.vue'
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'Form',
  components: {
    ValidationInput,
    ValidationObserver
  },
  props: {
    reg: Object,
  },
  data() {
    return {
      mailRules: {
        required: true,
        email: true
      },
      passwordRules: {
        required: true,
        regex: /^[\x21-\x7e]+$/,
        min: { length: 8 },
        max: { length: 32 },
        pass_strength: true,
        pass_is_not_id: ['@mail', '@user_name']
      },
      passwordConfirmRules: {
        required: true,
        confirmed: 'password'
      },
      userNameRules: { required: true },
      passwordConfirm: '',
      industryOptions: [
        { disabled: true, value: '', text: '選択してください' },
        { value: '土木一式工事', text: '土木一式工事' },
        { value: '建築一式工事', text: '建築一式工事' },
        { value: '大工工事', text: '大工工事' },
        { value: '左官工事', text: '左官工事' },
        { value: 'とび・土木・コンクリート工事', text: 'とび・土木・コンクリート工事' },
        { value: '石工事', text: '石工事' },
        { value: '屋根工事', text: '屋根工事' },
        { value: '電気工事', text: '電気工事' },
        { value: '管工事', text: '管工事' },
        { value: 'タイル・れんが・ブロック工事', text: 'タイル・れんが・ブロック工事' },
        { value: '鋼構造物工事', text: '鋼構造物工事' },
        { value: '鉄筋工事', text: '鉄筋工事' },
        { value: '舗装工事', text: '舗装工事' },
        { value: 'しゅんせつ工事', text: 'しゅんせつ工事' },
        { value: '板金工事', text: '板金工事' },
        { value: 'ガラス工事', text: 'ガラス工事' },
        { value: '塗装工事', text: '塗装工事' },
        { value: '防水工事', text: '防水工事' },
        { value: '内装仕上げ工事', text: '内装仕上げ工事' },
        { value: '機械器具設置工事', text: '機械器具設置工事' },
        { value: '熱絶縁工事', text: '熱絶縁工事' },
        { value: '電気通信工事', text: '電気通信工事' },
        { value: '造園工事', text: '造園工事' },
        { value: 'さく井工事', text: 'さく井工事' },
        { value: '建具工事', text: '建具工事' },
        { value: '水道施設工事', text: '水道施設工事' },
        { value: '消防施設工事', text: '消防施設工事' },
        { value: '清掃施設工事', text: '清掃施設工事' },
        { value: '解体工事', text: '解体工事' },
        { value: 'その他', text: 'その他' }
      ]
    }
  },
  created() {
    this.reg.editState = 'editing';
  },
  methods: {
    checkParams() {
      const args = {
        no_operation: true,
        mail: this.reg.mail,
        password: this.reg.password,
        user_name: this.reg.userName,
        company_name: this.reg.companyName,
        industry: this.reg.industry,
        receive_notification: this.reg.receiveNotification,
      }

      this.$store.dispatch('api/createKuraemonId', args).then((res) => {
        if ( this.$store.getters['api/apiError'] ) {
          return;
        }
        console.log(res);
        this.reg.editState = 'edited';
        this.$router.push({ name: 'new-registration-confirm' })
      })
    },
    isValid() {
      if (!this.$refs.mailInput
        || !this.$refs.passwordInput
        || !this.$refs.passwordConfirmInput
        || !this.$refs.userNameInput) return false;
      return this.$refs.mailInput.$children[0].flags.valid
        && this.$refs.passwordInput.$children[0].flags.valid
        && this.$refs.passwordConfirmInput.$children[0].flags.valid
        && this.$refs.userNameInput.$children[0].flags.valid;
    }
  },
}
</script>

<style scoped>
.wrap {
  padding: 1rem;
  margin: auto;
  width: 500px;
}
.title {
  font-size: 1.4rem;
  font-weight: bold;
  padding-left: 1rem;
  margin-bottom: 1rem;
}
.form-label {
  font-size: 0.9rem;
  font-weight: bold;
  padding-left: 1rem;
}
.form-row {
  margin: 0.5rem 0;
}
input[type="text"], input[type="email"], input[type="password"], select {
  border: solid 1px #333;
  border-radius: 0.25rem;
  width: 100%;
  padding: 0.3rem 0.5rem;
}
.checkbox-input {
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  -webkit-appearance: none;
  appearance: none;
  position: absolute;
}
.checkbox-parts {
  padding-left: 1.5rem;
  position:relative;
  margin-right: 1.5rem;
}
.checkbox-parts::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid #333;
  background: linear-gradient(#555, #444);
}
.checkbox-input:focus + .checkbox-parts::before {
  box-shadow: 0 0 0.4rem #333;
}
.checkbox-parts.checked::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 5px;
  width: 0.5rem;
  height: 1rem;
  transform: rotate(40deg);
  border-bottom: 3px solid white;
  border-right: 3px solid white;
}
.caption {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  text-align: center;
}
.btn-wrap {
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.next-btn {
  background-color: #333;
  color: white;
}
.next-btn:disabled {
  background-color: #999;
  color: #ccc;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>